import React, { useEffect, useState, useRef } from 'react';
import { SearchIcon, UserIcon, BellIcon, MenuIcon, XIcon, ChevronDownIcon } from 'lucide-react';
export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false); // For demo purposes
  const [activeMenu, setActiveMenu] = useState(null);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // For demo purposes only - toggle login state
  const toggleLogin = () => {
    setIsLoggedIn(!isLoggedIn);
  };
  const toggleMenu = menu => {
    setActiveMenu(activeMenu === menu ? null : menu);
  };
  return <header className={`fixed top-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-[#2b2b2b] shadow-md py-3' : 'bg-transparent py-5'}`} data-id="element-92">
      <div className="container mx-auto px-4 md:px-6" data-id="element-93">
        <div className="flex items-center justify-between" data-id="element-94">
          <div className="flex items-center" data-id="element-95">
            <a href="/" className="text-2xl font-bold text-white mr-10 tracking-tight" data-id="element-96">
              Kivarro
            </a>
            <nav className="hidden lg:flex space-x-8" data-id="element-97">
              <div className="relative group" data-id="element-98">
                <button onClick={() => toggleMenu('training')} className="text-white hover:text-[#1ddbdb] transition-colors font-medium flex items-center" data-id="element-99">
                  Training
                  <ChevronDownIcon className={`ml-1 h-4 w-4 transition-transform ${activeMenu === 'training' ? 'rotate-180' : ''}`} data-id="element-100" />
                </button>
                {activeMenu === 'training' && <div className="absolute top-full left-0 mt-2 w-[600px] bg-white rounded-lg shadow-xl p-6 grid grid-cols-2 gap-4 z-50" data-id="element-101">
                    <div data-id="element-102">
                      <h4 className="text-[#2b2b2b] font-semibold mb-3 text-sm uppercase tracking-wider" data-id="element-103">
                        Compliance
                      </h4>
                      <ul className="space-y-2" data-id="element-104">
                        <li data-id="element-105">
                          <a href="/training/food-safety" className="text-[#2b2b2b]/80 hover:text-[#0b757a] transition-colors" data-id="element-106">
                            Food Safety
                          </a>
                        </li>
                        <li data-id="element-107">
                          <a href="/training/health-safety" className="text-[#2b2b2b]/80 hover:text-[#0b757a] transition-colors" data-id="element-108">
                            Health & Safety
                          </a>
                        </li>
                        <li data-id="element-109">
                          <a href="/training/gdpr" className="text-[#2b2b2b]/80 hover:text-[#0b757a] transition-colors" data-id="element-110">
                            GDPR & Data Protection
                          </a>
                        </li>
                        <li data-id="element-111">
                          <a href="/training/fire-safety" className="text-[#2b2b2b]/80 hover:text-[#0b757a] transition-colors" data-id="element-112">
                            Fire Safety
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div data-id="element-113">
                      <h4 className="text-[#2b2b2b] font-semibold mb-3 text-sm uppercase tracking-wider" data-id="element-114">
                        Professional Skills
                      </h4>
                      <ul className="space-y-2" data-id="element-115">
                        <li data-id="element-116">
                          <a href="/training/leadership" className="text-[#2b2b2b]/80 hover:text-[#0b757a] transition-colors" data-id="element-117">
                            Leadership & Management
                          </a>
                        </li>
                        <li data-id="element-118">
                          <a href="/training/customer-service" className="text-[#2b2b2b]/80 hover:text-[#0b757a] transition-colors" data-id="element-119">
                            Customer Service
                          </a>
                        </li>
                        <li data-id="element-120">
                          <a href="/training/digital" className="text-[#2b2b2b]/80 hover:text-[#0b757a] transition-colors" data-id="element-121">
                            Digital Skills
                          </a>
                        </li>
                        <li data-id="element-122">
                          <a href="/training/all" className="text-[#0b757a] font-medium flex items-center" data-id="element-123">
                            View All Courses{' '}
                            <ChevronDownIcon className="ml-1 h-4 w-4 rotate-270" data-id="element-124" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>}
              </div>
              <div className="relative group" data-id="element-125">
                <button onClick={() => toggleMenu('enterprise')} className="text-white hover:text-[#1ddbdb] transition-colors font-medium flex items-center" data-id="element-126">
                  Enterprise
                  <ChevronDownIcon className={`ml-1 h-4 w-4 transition-transform ${activeMenu === 'enterprise' ? 'rotate-180' : ''}`} data-id="element-127" />
                </button>
                {activeMenu === 'enterprise' && <div className="absolute top-full left-0 mt-2 w-[400px] bg-white rounded-lg shadow-xl p-6 z-50" data-id="element-128">
                    <h4 className="text-[#2b2b2b] font-semibold mb-3 text-sm uppercase tracking-wider" data-id="element-129">
                      Enterprise Solutions
                    </h4>
                    <ul className="space-y-2" data-id="element-130">
                      <li data-id="element-131">
                        <a href="/enterprise/teams" className="text-[#2b2b2b]/80 hover:text-[#0b757a] transition-colors" data-id="element-132">
                          Team Training
                        </a>
                      </li>
                      <li data-id="element-133">
                        <a href="/enterprise/academy" className="text-[#2b2b2b]/80 hover:text-[#0b757a] transition-colors" data-id="element-134">
                          Custom Academy
                        </a>
                      </li>
                      <li data-id="element-135">
                        <a href="/enterprise/pricing" className="text-[#2b2b2b]/80 hover:text-[#0b757a] transition-colors" data-id="element-136">
                          Enterprise Pricing
                        </a>
                      </li>
                      <li data-id="element-137">
                        <a href="/enterprise/demo" className="text-[#0b757a] font-medium flex items-center" data-id="element-138">
                          Book a Demo{' '}
                          <ChevronDownIcon className="ml-1 h-4 w-4 rotate-270" data-id="element-139" />
                        </a>
                      </li>
                    </ul>
                  </div>}
              </div>
              <div className="relative group" data-id="element-140">
                <button onClick={() => toggleMenu('resources')} className="text-white hover:text-[#1ddbdb] transition-colors font-medium flex items-center" data-id="element-141">
                  Resources
                  <ChevronDownIcon className={`ml-1 h-4 w-4 transition-transform ${activeMenu === 'resources' ? 'rotate-180' : ''}`} data-id="element-142" />
                </button>
                {activeMenu === 'resources' && <div className="absolute top-full left-0 mt-2 w-[400px] bg-white rounded-lg shadow-xl p-6 z-50" data-id="element-143">
                    <h4 className="text-[#2b2b2b] font-semibold mb-3 text-sm uppercase tracking-wider" data-id="element-144">
                      Free Resources
                    </h4>
                    <ul className="space-y-2" data-id="element-145">
                      <li data-id="element-146">
                        <a href="/resources/checklists" className="text-[#2b2b2b]/80 hover:text-[#0b757a] transition-colors" data-id="element-147">
                          Compliance Checklists
                        </a>
                      </li>
                      <li data-id="element-148">
                        <a href="/resources/templates" className="text-[#2b2b2b]/80 hover:text-[#0b757a] transition-colors" data-id="element-149">
                          Audit Templates
                        </a>
                      </li>
                      <li data-id="element-150">
                        <a href="/resources/guides" className="text-[#2b2b2b]/80 hover:text-[#0b757a] transition-colors" data-id="element-151">
                          Compliance Guides
                        </a>
                      </li>
                      <li data-id="element-152">
                        <a href="/resources/all" className="text-[#0b757a] font-medium flex items-center" data-id="element-153">
                          All Resources{' '}
                          <ChevronDownIcon className="ml-1 h-4 w-4 rotate-270" data-id="element-154" />
                        </a>
                      </li>
                    </ul>
                  </div>}
              </div>
              <a href="/about" className="text-white hover:text-[#1ddbdb] transition-colors font-medium" data-id="element-155">
                About
              </a>
            </nav>
          </div>
          <div className="hidden lg:flex items-center space-x-6" data-id="element-156">
            <button onClick={toggleLogin} className="px-5 py-2 rounded-md transition-all duration-300 bg-[#0b757a] text-white hover:bg-[#096469] shadow-md" data-id="element-157">
              {isLoggedIn ? 'Dashboard' : 'Login'}
            </button>
            <button className="text-white hover:text-[#1ddbdb] transition-colors" data-id="element-158">
              <SearchIcon size={20} data-id="element-159" />
            </button>
            <div className="relative" data-id="element-160">
              <button className="text-white hover:text-[#1ddbdb] transition-colors" data-id="element-161">
                <BellIcon size={20} data-id="element-162" />
              </button>
              <span className="absolute -top-1 -right-1 w-4 h-4 bg-[#1ddbdb] rounded-full flex items-center justify-center text-white text-xs animate-pulse" data-id="element-163">
                2
              </span>
            </div>
            <div className="relative" data-id="element-164">
              <button className="text-white hover:text-[#1ddbdb] transition-colors" data-id="element-165">
                <UserIcon size={20} data-id="element-166" />
              </button>
            </div>
          </div>
          <button className="lg:hidden text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-167">
            {isMobileMenuOpen ? <XIcon size={24} data-id="element-168" /> : <MenuIcon size={24} data-id="element-169" />}
          </button>
        </div>
        {/* Mobile menu */}
        {isMobileMenuOpen && <div className="lg:hidden mt-4 pb-4" data-id="element-170">
            <nav className="flex flex-col space-y-4" data-id="element-171">
              <a href="/training" className="text-white hover:text-[#1ddbdb] transition-colors" data-id="element-172">
                Training
              </a>
              <a href="/enterprise" className="text-white hover:text-[#1ddbdb] transition-colors" data-id="element-173">
                Enterprise
              </a>
              <a href="/resources" className="text-white hover:text-[#1ddbdb] transition-colors" data-id="element-174">
                Resources
              </a>
              <a href="/about" className="text-white hover:text-[#1ddbdb] transition-colors" data-id="element-175">
                About
              </a>
            </nav>
            <div className="flex items-center space-x-6 mt-4" data-id="element-176">
              <button onClick={toggleLogin} className="px-5 py-2 rounded-md transition-all duration-300 bg-[#0b757a] text-white hover:bg-[#096469]" data-id="element-177">
                {isLoggedIn ? 'Dashboard' : 'Login'}
              </button>
              <button className="text-white hover:text-[#1ddbdb] transition-colors" data-id="element-178">
                <SearchIcon size={20} data-id="element-179" />
              </button>
              <div className="relative" data-id="element-180">
                <button className="text-white hover:text-[#1ddbdb] transition-colors" data-id="element-181">
                  <BellIcon size={20} data-id="element-182" />
                </button>
                <span className="absolute -top-1 -right-1 w-4 h-4 bg-[#1ddbdb] rounded-full flex items-center justify-center text-white text-xs animate-pulse" data-id="element-183">
                  2
                </span>
              </div>
              <div className="relative" data-id="element-184">
                <button className="text-white hover:text-[#1ddbdb] transition-colors" data-id="element-185">
                  <UserIcon size={20} data-id="element-186" />
                </button>
              </div>
            </div>
          </div>}
      </div>
    </header>;
};